import React from "react";
import { apiPath } from "../utilities/Constants";
import useFetch from "../hooks/useFetch";
import GlobalForm from "../components/globalForm/GlobalForm";
import { updateData } from "../hooks/update";
import Loader from "../components/shared/Loader/Loader";
import LoaderFilling from "../components/shared/Loader/LoaderFilling";

function PlatformPage() {
  const { homeApi } = apiPath;
  const [apiData, apiDataLoading] = useFetch(homeApi);

  if (apiDataLoading) {
    return <LoaderFilling />;
  }

  const { logo, logoWhite, _id } = apiData[0] ?? {};

  // Form data
  const data = [
    {
      elementType: "heading",
      label: `Update Logo`,
      name: "heading",
      type: "heading",
      firstElement: true,
    },
    {
      elementType: "file",
      label: `Logo - Colored`,
      name: "logo",
      type: "file",
      fullCol: true,
      defaultValue: { url: logo },
      required: false,
    },
    {
      elementType: "file",
      label: `Logo - White`,
      name: "logoWhite",
      type: "file",
      fullCol: true,
      defaultValue: { url: logoWhite },
      required: false,
    },
  ];

  const update = (data) => {
    delete data.heading;

    // data.heroImg = heroImg;
    updateData(homeApi, data, _id);
  };

  return <div>{_id && <GlobalForm data={data} update={update} />}</div>;
}

export default PlatformPage;
